import React, { useEffect, useState } from 'react';
import {
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import { User, LogOut } from 'lucide-react';
import { useLogout, useGetIdentity } from 'react-admin';
import { supabase } from '../../../services/supabase';

export const UserAvatar: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [sessionEmail, setSessionEmail] = useState<string | null>(null);
  const logout = useLogout();
  const { data: identity, isLoading } = useGetIdentity();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    logout();
  };

  useEffect(() => {
    supabase.auth
      .getSession()
      .then(({ data, error }) => {
        if (!error && data.session?.user?.email) {
          setSessionEmail(data.session.user.email);
        }
      })
      .catch(() => {
        // Non-blocking: ignore session lookup errors for menu display
      });
  }, []);

  if (isLoading) {
    return (
      <IconButton color="inherit">
        <Avatar sx={{ width: 32, height: 32 }}>
          <User />
        </Avatar>
      </IconButton>
    );
  }

  const email = identity?.email || sessionEmail;

  return (
    <>
      <IconButton color="inherit" onClick={handleClick}>
        <Avatar sx={{ width: 32, height: 32 }}>
          {email ? email.charAt(0).toUpperCase() : <User />}
        </Avatar>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        PaperProps={{
          sx: { minWidth: 200 },
        }}
      >
        <Box sx={{ padding: 2 }}>
          {email ? (
            <Typography variant="body2" noWrap>
              {email}
            </Typography>
          ) : (
            <Typography variant="subtitle2" noWrap>
              User
            </Typography>
          )}
        </Box>

        <Divider />

        <MenuItem onClick={handleLogout}>
          <LogOut style={{ marginRight: 8 }} />
          Sign out
        </MenuItem>
      </Menu>
    </>
  );
};
